<template>
  <v-app>
    <section class="banner">
      <v-parallax height="600" src="@/assets/images/banner.webp">
        <v-row justify="center" align="center" class="black--text mx-auto">
          <v-col class="6">
            <v-icon size="100" color="green">
              mdi-check-circle-outline
            </v-icon>
            <h2>
                Hemos recibido tu pago con éxito. 
            </h2>
          </v-col>
        </v-row>
        <v-row justify="center" align="start" class="black--text">
          <v-col xl="3" lg="3" md="4" sm="12" class="mx-auto">
            <strong>¡Estamos felices de volvernos a encontrar!</strong><br>
            Si estás preparado para realizar tu primera publicación ¡pues adelante! 
            Si aún no estás listo, puedes revisar tu perfil o actualizar los datos de tu organización ingresando a cuenta.
            En caso de cualquier duda o inconveniente escríbenos a <a href = "mailto:hola@trabajoconsentido.com">hola@trabajoconsentido.com</a>
            <p>*No olvides que tienes hasta 1 año para publicar.</p>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col xl="4" lg="4" md="4" sm="5" class="mx-auto d-flex flex-xl-row flex-lg-row  flex-column justify-space-around">
            <v-btn to="/login" color="#3badff" dark large>
                PUBLICAR OFERTA
            </v-btn>
            <v-btn to="/login" color="#3badff" dark large>
                VER PERFIL
            </v-btn>
          </v-col>
        </v-row>
      </v-parallax>
    </section>
  </v-app>
</template>

<script>
export default {
    name: "OfflinePayment",

    props: ["payment"],

    data() {
        return {
        };
    },

    created() {
        this.dataPayment = this.$route.query;
    },

    computed: {
        getValor() {
            let result = this.dataPayment.query && this.dataPayment.query.valor || this.packs[this.payment.bucketCode].valor; 
            let skip = result > 99999 ? 3 : 2;
            return  result.toString().slice(0, skip) + "." + result.toString().slice(skip);
        },
        getTAX() {
            let result = (this.dataPayment.query && this.dataPayment.query.valor || this.packs[this.payment.bucketCode].valor * 0.19).toFixed(0); 
            let skip = result > 99999 ? 3 : 2;
            return  result.toString().slice(0, skip) + "." + result.toString().slice(skip);
        },
        getTotal() {
            let result = (this.dataPayment.query && this.dataPayment.query.valor || this.packs[this.payment.bucketCode].valor * 1.19).toFixed(0); 
            let skip = result > 99999 ? 3 : 2;
            return  result.toString().slice(0, skip) + "." + result.toString().slice(skip);
        }
    },
};
</script>
